import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesNotesAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesNotes() {
  return fetchApi('/v1/fc_api/feeding_guidelines_notes_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesNotes;
